import React from "react";
import { Link, useLocation } from "react-router-dom";
import { TopBarWrapper, ButtonTab, CloseButton } from "./TopBarProfileStyles";

const TopBarProfile = () => {
  const location = useLocation();

  const authRaw = localStorage.getItem("user");
  const authUser = authRaw ? JSON.parse(authRaw) : null;

  // ❌ NU e user sau nu e rol utilizator → nu afișezi nimic
  if (!authUser || authUser.role !== "utilizator") {
    return null;
  }

  const isProfile = location.pathname === "/profil";
  const isOrders = location.pathname === "/comenzi";

  return (
    <TopBarWrapper>
      <div style={{ display: "flex", gap: "1rem" }}>
        <Link to="/profil" style={{ textDecoration: "none" }}>
          <ButtonTab active={isProfile}>Profil</ButtonTab>
        </Link>

        <Link to="/comenzi" style={{ textDecoration: "none" }}>
          <ButtonTab active={isOrders}>Comenzi</ButtonTab>
        </Link>
      </div>

      <Link to="/" style={{ textDecoration: "none" }}>
        <CloseButton>&times;</CloseButton>
      </Link>
    </TopBarWrapper>
  );
};

export default TopBarProfile;
